export default {
      id: "breadroll-usage",
      viewBox: "0 0 103 103",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#breadroll",
      toString: function () {
        return this.url;
      }
    }